<div *ngIf="selectItems | async as _selectItems" id="searcher-start" class="p-2">
    <div class="grid">
        <div class="col-12">
            <p-panel header="Tevékenységek szűrése" [toggleable]="true" [collapsed]="true">
                <div class="only-big-flex items-center gap-4 my-4">
                    <label class="font-semibold w-4">Tevékenységet nyújtó szervezet</label>
                    <div class="flex-auto mb-2">
                        @if (!isMobile) {
                            <p-select [options]="partnerList()" optionLabel="name" optionValue="id"
                                      [fluid]="true" showClear="true" [scrollHeight]="'500px'"
                                      [(ngModel)]="activityFilterClientPartner"
                                      [ngModelOptions]="{standalone: true}"></p-select>
                        }
                        @if (isMobile) {
                            <select class="p-select flex text-black-alpha-90" [(ngModel)]="activityFilterClientPartner"
                                    [ngModelOptions]="{standalone: true}"
                                    [ngStyle]="{width: '100%', padding: '0.75rem', background: 'white', borderRadius: '4px'}">
                                <option [value]="null">-</option>
                                @for (partner of partnerList(); track $index) {
                                    <option [value]="partner.id"> {{partner.name}}</option>
                                }
                            </select>
                        }
                    </div>
                </div>
                <div class="only-big-flex flex-wrap gap-4 mb-2">
                    <label class="font-semibold w-4">Tevékenység neve</label>
                    <div class="flex-auto mb-4">
                        <input pInputText autocomplete="off" (keydown.enter)="filterActivities()" [fluid]="true"
                               [(ngModel)]="activityFilterName" [ngModelOptions]="{standalone: true}"/>
                    </div>
                </div>
                <div class="only-big-flex flex-wrap gap-4 mb-4">
                    <label class="font-semibold w-4">Tevékenység tulajdonságai</label>
                    <div class="flex-auto mb-2">
                        @if (!isMobile) {
                            <p-multiSelect [options]="_selectItems | selectItem: 'activityLabel'" [fluid]="true" [filter]="true"
                                           showClear="true" [scrollHeight]="'500px'"
                                           [(ngModel)]="eventFilterCategories"
                                           [ngModelOptions]="{standalone: true}"
                                           display="chip"></p-multiSelect>
                        }
                        @if (isMobile) {
                            <select class="p-select flex text-black-alpha-90" [(ngModel)]="eventFilterCategories"
                                    [ngModelOptions]="{standalone: true}" [multiple]="true"
                                    [ngStyle]="{width: '100%', padding: '0.75rem', background: 'white', borderRadius: '4px'}">
                                @for (selectItems of getFilterCategories(_selectItems); track $index) {
                                    <option [value]="selectItems.value"> {{selectItems.label}}</option>
                                }
                            </select>
                        }
                    </div>
                </div>
                <div class="col-12" [ngStyle]="{textAlign: 'end'}">
                    <button pButton label="Szűrés" (click)="filterActivities()" type="button"
                            [ngStyle]="{width: '150px'}"></button>
                </div>
            </p-panel>
        </div>
        <div class="col-12">
            <div class="flex gap-2 justify-content-center" [ngStyle]="{marginTop: '3rem'}">
                <div [ngStyle]="{width: '400px'}">
                    <button pButton
                            (click)="activitySelected()"  [disabled]="!selectedActivity" type="button">
                        <span pButtonLabel>Tevékenység kiválasztása</span>
                    </button>
                </div>
            </div>
        </div>
        @for (activity of getActivityList(); track activity.id) {
            <div class="col-12 md:col-6" (dblclick)="this.selectedActivity=activity;activitySelected()">
                <div class="align-content-center p-3 selectable-event" [ngStyle]="{height: '11rem', width: '100%'}"
                     (click)="selectedActivity = activity"
                     [ngClass]="{'selected': activity.id === selectedActivity?.id}">
                    <div class="md:text-xl pb-2">
                        <div class="overflow-hidden text-overflow-ellipsis"
                             [ngStyle]="{display: '-webkit-box', '-webkit-line-clamp': 2, '-webkit-box-orient': 'vertical'}">
                            {{ activity.name }}
                        </div>
                        <i class="pi pi-info-circle" (click)="activityDescription.toggle($event)"
                                        [ngStyle]="{height: '4rem'}"></i>
                    </div>
                    <div class="text-sm md:text-l mb-2 underline overflow-hidden text-overflow-ellipsis"
                         [ngStyle]="{display: '-webkit-box', '-webkit-line-clamp': 2, '-webkit-box-orient': 'vertical'}">
                        <a class="link-button" target="_blank" (click)="openPartnerDescription(activity.partnerClient)">{{activity.partnerClient.name}}</a>
                    </div>
                    <div class="slideshow-button-container">
                        <small class="text-sm overflow-hidden text-overflow-ellipsis"
                               [ngStyle]="{display: '-webkit-box', '-webkit-line-clamp': 3, '-webkit-box-orient': 'vertical'}">
                            {{activity.description}}
                        </small>
                    </div>


                    <p-popover #activityDescription>
                        <div class="flex grid overflow-auto"
                             [ngStyle]="{maxWidth: '40rem', maxHeight: '25rem'}">
                            <h4 class="col-12 text-center"
                                [ngStyle]="{color: '#3F7467FF', margin: 0}">{{ activity.name }}</h4>
                            <div class="col-12 text-center"><i class="pi pi-info-circle"
                                                               [ngStyle]="{fontSize: '2rem', color: '#3F7467FF'}"></i>
                            </div>
                            <div class="col-12 text-center">
                                                    <span class="font-bold"
                                                          [ngStyle]="{color: '#3F7467FF'}">Időtartam: </span>{{ activity.length }}
                                óra
                            </div>
                            <div class="col-12 text-center">
                                                    <span class="font-bold"
                                                          [ngStyle]="{color: '#3F7467FF'}">Leírás: </span>
                                {{ activity.description }}
                            </div>
                            <div class="col-12 text-center">
                                <button pButton
                                        [label]="'OK'" type="button"
                                        (click)="activityDescription.toggle($event)"></button>
                            </div>
                        </div>
                    </p-popover>
                </div>
            </div>
        }
    </div>
    <div class="flex gap-2 justify-content-center" [ngStyle]="{marginTop: '3rem'}">
        <div [ngStyle]="{width: '400px'}">
            <button pButton
                    (click)="activitySelected()"  [disabled]="!selectedActivity" type="button">
                <span pButtonLabel>Tevékenység kiválasztása</span>
            </button>
        </div>
    </div>
</div>

@if (showButton) {
    <button pButton id="scrollTopBtn" class="" icon="pi pi-arrow-circle-up"  (click)="scrollToTop()"
        [ngStyle]="{width: '75px', height: '75px', borderRadius: '50%'}"></button>
}

<p-dialog [(visible)]="showDialog" [ngStyle]="{width: '50%'}" [header]="selectedActivity?.partnerClient?.name + ' adatai'">
        <hr style="border:none; border-top:2px solid #eee; margin-bottom:20px" />
    <div [innerHTML]="testHtml()" [ngStyle]="{maxWidth: '1000px'}"></div>
</p-dialog>
